<!--  -->
<template>
 <div>
   <div class="myplan-main-box">
    <banner></banner>
    <div class="history-main">
      <div @click="$router.go(-1)" class="history-main-back">
        <Icon type="ios-arrow-back" class="icon-back" />返回
      </div>
      <div class="history-main-select change-style-select">
        <Select v-model="id" style="width:256px" @on-change="planFollowTemplate" placeholder="请选择阶段">
            <Option v-for="item in phaseListAudit" :value="item.id" :key="item.name">{{ item.name}}</Option>
        </Select>
      </div>
      <div v-if="id">
      <div class="history-main-sum">
          <div class="history-main-sum-left">
            <div class="circle-box">
              <i-circle
                  :size="110"
                  :trail-width="4"
                  :stroke-width="5"
                  :percent="perecentData"
                  :stroke-color="strokeColor">
                  <div class="demo-Circle-custom">
                      <span>{{planCurrentPhases.finishCount}}/{{planCurrentPhases.sum}}</span>
                      <strong>{{Number(planCurrentPhases.sum) === 0?0:perecentDataOld}}%</strong>
                  </div>
              </i-circle>
            </div>
            <div>
              <strong style="font-weight: normal;">{{planCurrentPhases.name}}-申请规划完成度</strong>
              <span>加油，接下来两周还需加倍努力！</span>
            </div>
          </div>
          <div class="history-main-sum-right">
            <strong>总结</strong>
            <span>{{trackSummary?trackSummary:'--'}}</span>
          </div>
      </div>
      <div class="history-main-item">
         <div  class="history-main-item-list">
           <myplan-history-progress  :planCurrentPhases="planCurrentPhases"></myplan-history-progress>
         </div>
          <!-- <div  class="history-main-item-list">
           <myplan-history-progress :magementList="magementList" :isComplete="false"></myplan-history-progress>
         </div> -->
      </div>
      </div>
      <!-- <div class="history-main-btn">
          <div class="btn-item">
            <span><Icon type="ios-chatbubbles" class="img-btn" /></span>
            <a href="" class="btn-text">点击绑定微信</a>
          </div>
          <div class="btn-item">
            <span><Icon type="md-list-box" class="img-btn" /></span>
            <a href="" class="btn-text">定期收取总结报告</a>
          </div>
      </div> -->
    </div>
   </div>
 </div>
</template>
<script>
// less
import './myplan.less'
import Banner from './components/banner'
import MyplanHistoryProgress from './components/myplan-history-progress'
import { planQueryPhasesListAudit, planMenteePhasesInfo } from '@/api/data-myplan'
export default {
  name: 'myplan-history',
  components: {
    Banner,
    MyplanHistoryProgress
  },
  data () {
    return {
      id: '',
      phaseListAudit: [],
      planCurrentPhases: {
        finishCount: 0,
        sum: 0
      },
      strokeColor: '#6589dd',
      trackSummary: ''
    }
  },
  computed: {
    perecentData () {
      let num = Number(((this.planCurrentPhases.finishCount / this.planCurrentPhases.sum) * 100).toFixed(0)) > 100 ? 100 : Number(((this.planCurrentPhases.finishCount / this.planCurrentPhases.sum) * 100).toFixed(0))
      return num
    },
    perecentDataOld () {
      let num = Number(((this.planCurrentPhases.finishCount / this.planCurrentPhases.sum) * 100).toFixed(0))
      return num
    }
  },
  mounted () {
    // 获取规划内阶段列表，跟进记录下拉框调用
    this.planQueryPhasesListAudit()
    // this.planMenteePhasesInfo('')
  },
  methods: {
    // 获取规划内阶段列表，跟进记录下拉框调用
    planQueryPhasesListAudit () {
      planQueryPhasesListAudit().then(res => {
        if (res.code === 0) {
          this.phaseListAudit = res.data.model
        }
      })
    },
    // 跟进阶段模板
    planFollowTemplate () {
      this.planMenteePhasesInfo(this.id)
    },
    // 获取某个阶段规划信息
    planMenteePhasesInfo (id) {
      let data = {}
      data.id = id
      planMenteePhasesInfo(data).then(res => {
        if (res.code === 0) {
          this.planCurrentPhases = res.data.info
          this.planCurrentPhases.finishCount = Number(res.data.info.finishCount)
          this.planCurrentPhases.sum = Number(res.data.info.sum)
          this.strokeColor = res.data.degree ? res.data.degree.color : '#6589dd'
          this.trackSummary = res.data.trackSummary
        }
      })
    }
  }
}
</script>
<style lang='less' scoped>
.history-main {
  width:1280px;
  margin:0 auto;
  &-back{
    font-size:18px;
    .icon-back{
      color:#000000;
      font-size:24px;
      padding-right:19px;
    }
    cursor:pointer;
  }
  &-select{
    margin:42px 0 61px;
    display:flex;
    justify-content: center;
  }
  &-sum{
    display: flex;
    padding:41px 72px;
    background: #FFFFFF;
    border-radius: 2px;
    span,strong{
      display: block;
      line-height: 20px;
    }
    strong{
      padding-bottom:13px;
    }
    &-left {
      display: flex;
      width:470px;
      align-items: center;
      .circle-box{
        width:110px;
        height:110px;
        margin-right:46px;
        strong{
          font-size:24px;
          padding-top:9px;
        }
      }
      strong{
        font-size: 24px;
      }
    }
    &-right{
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-left:99px;
      border-left:1px solid #EBEBEB;
      strong{
        font-size:20px;
      }
    }
  }
  &-item{
    display: flex;
    margin-top:40px;
    justify-content: space-between;
    &-list{
      padding:38px 0 20px;
      background: #FFFFFF;
      border-radius: 2px;
      width:100%;
    }
  }
  &-btn{
    width:400px;
    margin:70px auto;
    display: flex;
    justify-content: space-between;
    .btn-item{
      display: flex;
      flex-direction: column;
      align-items: center;
      .btn-text{
        text-decoration: underline;
        font-size:20px;
        color:#6589DD;
        padding-top:18px;
      }
    }
  }
}
.img-btn {
  font-size:24px;
  color:#6589DD;
}

</style>
<style lang='less'>
.change-style-select.history-main-select .ivu-select-single .ivu-select-selection{
  height:50px;
  background:#F0F0F0;
  border:0;
}
.change-style-select.history-main-select .ivu-select-single .ivu-select-selection .ivu-select-placeholder,.change-style-select.history-main-select .ivu-select-single .ivu-select-selection .ivu-select-selected-value{
  height:48px;
  line-height:48px;
  font-size:18px;
  color:#333333;
  font-weight: bold;
  padding-left:24px;
}
.change-style-select.history-main-select .ivu-select-single .ivu-select-selection .ivu-select-placeholder{
  color: #c5c8ce;
  font-size:16px;
}
.change-style-select.history-main-select .ivu-select-arrow{
  right:20px;
  font-size:16px;
}
</style>
